/* eslint-disable no-useless-concat */
import { LANGUAGE_CODES } from "../constants/config-constants";
import MuleFetchUtil from "../common/mule-fetch-util";
import { format } from 'date-fns';
import { refreshTokenAPIService } from "../services/SessionService";
import { detectIncognito } from "detectincognitojs";
import { v4 as uuidv4 } from 'uuid';

export const getCountryCode = () => {
  // return  env.COUNTRY_CODE;
  return "VN";
};

export const getLanguageCode = () => {
  // const countryCode = getCountryCode();
  let languageCode;
  // switch (countryCode) {
  //   case MARKETS.VIETNAM: {
  //     languageCode = LANGUAGE_CODES.VN;
  //     break;
  //   }
  //   default: {
  //     languageCode = LANGUAGE_CODES.EN;
  //   }
  // }
  languageCode = LANGUAGE_CODES.EN;

  return languageCode;
};

export const setCookie = (name, value) => {
  const cookieValue = value + "; path=/";
  document.cookie = name + "=" + cookieValue;
};
export const getCookie = (name) => {
  const cookies = document.cookie.split("; ");
  let result = null;
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].split("=");
    const cookieName = cookie[0];
    const cookieValue = cookie[1];
    // console.log(cookieName,cookieValue)
    if (cookieName === name) {
      result = cookieValue;
      break;
    }
  }
  return result;
};
export const deleteCookie = (name) => {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
};

let isLoggingOut = false;
const TOKEN_REFRESH_TIMESTAMP_KEY = "tokenRefreshAttemptAt";
const TOKEN_REFRESH_COOLDOWN_MS = 60 * 1000;

/** End an invalid session once, even when several requests fail together. */
export const LogoutInvalidToken = () => {
  if (isLoggingOut) return;
  isLoggingOut = true;
  document.cookie =
    "idToken" + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie =
    "refreshToken" + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  alert("Something went wrong. please login again");
  window.location.assign("/login");
};

let isRefreshing = false;


/**
 * Refresh once per minute across reloads; repeated failures end the session.
 * Fail closed if session storage cannot persist the reload-loop guard.
 */
export const RefreshTokenReload = async (refreshToken) => {
  if (isRefreshing || isLoggingOut) return;
  if (!refreshToken) {
    LogoutInvalidToken();
    return;
  }

  try {
    const lastAttempt = sessionStorage.getItem(TOKEN_REFRESH_TIMESTAMP_KEY);
    const now = Date.now();
    if (
      lastAttempt !== null &&
      (!Number.isFinite(Number(lastAttempt)) ||
        now - Number(lastAttempt) < TOKEN_REFRESH_COOLDOWN_MS)
    ) {
      LogoutInvalidToken();
      return;
    }
    sessionStorage.setItem(TOKEN_REFRESH_TIMESTAMP_KEY, String(now));
  } catch (error) {
    console.error("Unable to persist token refresh guard:", error);
    LogoutInvalidToken();
    return;
  }
  isRefreshing = true;

  let obj = {
    grant_type: "refresh_token",
    refresh_token: refreshToken,
  };
  const countryCode = localStorage.getItem("countryCode");
  const oldToken = getCookie("idToken");
  let result = MuleFetchUtil.post(
    "fb/accounts/refreshtoken",
    { customerToken: oldToken, countryCode: countryCode },
    obj,
    "signInWithPassword"
  );
  return result.then(async (response) => {
    if (response.statusCode === 200 && response["response-data"].id_token) {
      const newToken = response["response-data"].id_token;
      setCookie("idToken", newToken);
      await refreshTokenAPIService(countryCode, oldToken, newToken);
      if (!isLoggingOut) window.location.reload();
    } else {
     
      LogoutInvalidToken();
    }
    isRefreshing = false;
  }).catch((err) => {
    console.error("Error refreshing token:", err);
    isRefreshing = false;

    LogoutInvalidToken();
  });
};

export const sortCountryArray = (countries) => {
  const dummy = ["id","idic","vn", "ph", "th","pk","bd","my"];
  const sortedCountryArray = countries.sort((a, b) => {
    return dummy.indexOf(a) - dummy.indexOf(b);
  });
  return sortedCountryArray;
};

export const dateTimeFormatter = (props) => {
  if (props.value) {
    try {
      let date = format(new Date(props.value), 'dd-MMM-yy | HH:mm');
      return date;
    } catch (e) {
      return '--';
    }
  } else {
    return '--';
  }
};

export const getUserAgent = async () => {
  let userAgent = navigator.userAgent.toLowerCase();
  let uuID = localStorage.getItem("UUID") || uuidv4();  
  let deviceId = userAgent + uuID;
  const isIncognito = await detectIncognito();
  if (isIncognito.isPrivate) {
    deviceId += " incognito";
  }
  return deviceId;
}
